import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, map, take } from 'rxjs';
import { ACCESS_TOKEN, ROLES } from '../shared/constants/general.constants';
import { Toast } from '../shared/enums/toast';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, HelpersService, ToastService }   from '@evento-ng/libs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private helpers: HelpersService,
    private toast: ToastService,
    private permissionsService: NgxPermissionsService,
    private router: Router,
    private translate: TranslateService,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = this.helpers.getItemFromLocalStorage(ACCESS_TOKEN);
    if (!token) {
      this.handleUnauthorized();
      return false;
    }

    return this.authService.user$.pipe(
      take(1),
      map(user => {
        if (user) {
          if (this.helpers.checkItemFromLocalStorage(ROLES)) {
            this.permissionsService.loadPermissions(
              this.helpers.getItemFromLocalStorage(ROLES)
            );
          }
          return true;
        }
        
        // Only fetch user if we don't have user data
        this.authService.fetchUser();
        return true;
      })
    );
  }

  private handleUnauthorized(): void {
    // Check if translation service is ready
    if (!this.translate.currentLang) {
      this.translate.setDefaultLang('ar');
      this.translate.use('ar');
    }

    // Use default messages if translation fails
    const title = this.translate.instant('Not Authorized') || 'Not Authorized';
    const message = this.translate.instant(
      'You are not authorized to access this page, Please login first!'
    ) || 'You are not authorized to access this page, Please login first!';

    this.toast.show(title, message, {
      classname: Toast.error,
    });
    
    this.router.navigateByUrl('/auth');
  }
}
